import React, { useState } from 'react'

import { Edit as EditIcon, Home as HomeIcon } from '@material-ui/icons'

import { AuditDialog } from 'src/modules/supply_chain/components/AuditDialog'
import {
  EnumField,
  GenericStatusField,
  PercentField,
  RelatedLinkedField,
  ValueField,
} from 'src/components/Table'
import { Audit } from 'src/api/models'
import { DetailComponent } from './base'

interface ObjInfo {
  data: any
  isLoading: boolean
}

interface DetailTableProps {
  obj: ObjInfo
  refresh?: () => void
}

export const AuditDetailTable = (props: DetailTableProps) => {
  const { obj, refresh } = props
  const [updateOpen, setUpdateOpen] = useState(false)

  return (
    <>
      {updateOpen && (
        <AuditDialog
          open={updateOpen}
          audit={obj.data}
          update
          handleClose={() => {
            setUpdateOpen(false)
          }}
          onSave={refresh}
        />
      )}
      <DetailComponent
        obj={obj}
        Icon={HomeIcon}
        menuItems={[
          {
            Icon: EditIcon,
            actions: [{ title: 'Edit Audit', onClick: () => setUpdateOpen(true) }],
          },
        ]}
        fields={[
          { id: 'guid', label: 'SquID', renderer: ValueField },
          { id: 'name', label: 'Name', renderer: ValueField },
          { id: 'facility', label: 'Facility', renderer: RelatedLinkedField(ValueField, 'name') },
          { id: 'auditType', label: 'Type', renderer: EnumField(Audit.Type) },
          { id: 'sku', label: 'SKU', renderer: RelatedLinkedField(ValueField, 'sku') },
          { id: 'notes', label: 'Notes', renderer: ValueField },
          {
            id: 'status',
            label: 'Status',
            renderer: GenericStatusField(Audit.statusDisplayMap, Audit.colorStatusMap),
          },
          {
            id: 'errorDisplay',
            label: 'Error Message',
            renderer: ValueField,
          },
          { id: 'accuracyScore', label: 'Accuracy Score', renderer: PercentField },
          { id: 'createdOn', label: 'Created On', renderer: ValueField },
          { id: 'updatedOn', label: 'Updated On', renderer: ValueField },
        ]}
      />
    </>
  )
}
